/**
 * react-google-recaptcha-v3 injectează badge-ul (și mesajul de eroare
 * „Invalid domain for site key") în document.body. La unmount, librăria
 * nu le scoate — rămân pe /app/containere după login.
 */
export function cleanupRecaptchaDom(): void {
  document.querySelectorAll('.grecaptcha-badge').forEach((el) => el.remove());

  document.querySelectorAll('iframe[src*="recaptcha"]').forEach((iframe) => {
    iframe.parentElement?.remove();
  });

  document.querySelectorAll('script[src*="recaptcha/api.js"], script[src*="recaptcha/enterprise.js"]').forEach((el) => {
    el.remove();
  });

  const w = window as Window & {
    grecaptcha?: unknown;
    ___grecaptcha_cfg?: unknown;
  };
  delete w.grecaptcha;
  delete w.___grecaptcha_cfg;
}
